import audienceMixin from '../Mixins/audiences-table';
import Prompt from '@core/Components/Util/Prompt.vue';
import {sprintf} from 'sprintf-js';
import {RouteNames, BuilderTabIds} from "@modules/AudienceManager/constants";

import { bootstrapSuccessGrowl, bootstrapDangerGrowl } from '../../../../../Util/growler';

import {createNamespacedHelpers} from 'vuex';
const {mapState,mapGetters,mapActions} = createNamespacedHelpers('audienceManager/overview');

export default {
    name: 'overview-concept',
    mixins: [audienceMixin],
    components: {
        Prompt
    },
    computed: {
        buttons() {
            // Sort of cheating, sort of wish i had realised this is way simpler earlier..
            // We are wrapping the button in a span with custom-button class and giving it a name.
            // Datatable component will emit the name and the audience that is in the row the button is in.
            // Normally we would use the datatable defaultContentType.button for this. But we can't get more than
            // one butten in a column that way.
            return `
                <span class="custom-button" name="edit" data-toggle="tooltip"
                    title="${this.resource('AudienceManager_Overview_Concept_Edit_Tooltip')}"
                >
                    <a href="javascript:void(0)" class="mdb-icon-btn edit">
                        <i class="fas fa-pencil-alt"></i>
                    </a>
                </span>
                <span class="custom-button" name="delete" data-toggle="tooltip"
                    title="${this.resource('AudienceManager_Overview_Concept_Delete_Tooltip')}"
                >
                    <a href="javascript:void(0)" class="mdb-icon-btn delete">
                        <i class="fas fa-trash-alt"></i>
                    </a>
                </span>`;
        },
        promptButtons() {
            return [{
                name: this.resource('Bool_Yes'),
                class: 'btn btn-primary btn-sm',
                emit: 'yes'
            }, {
                name:  this.resource('Bool_No'),
                class: 'btn btn-secondary btn-sm',
                emit: 'no'
            }];
        },
        allColumns() {
            return [
                ...this.columns, { 
                    title: this.resource('AudienceManager_OverView_Concept_Action'),
                    defaultContent: this.buttons, 
                    sortable: false
                }
            ];
        },
        promptBody() {
            const vm = this;

            return sprintf(
                vm.resource('AudienceManager_OverView_Delete_Audience_Prompt_Body'), 
                vm.audienceToDelete ? vm.audienceToDelete.name : ''
            );
        },
        conceptAudiences() {
            const vm = this;
            return Object.values(vm.audiences).filter((audience) => audience.status === vm.status.concept);
        },
        audienceToDelete() {
            return this.getAudience(this.idToDelete);
        },
        sortedTabs() {
            return this.$store.getters['audienceManager/builder/sortedTabs'];
        },
        targetBuilderTab() {
            return this.sortedTabs.length ? RouteNames.BUILDER_QUESTION_TAB : RouteNames.BUILDER_QUICKSTART_TAB
        },
        targetTabId() {
            return this.sortedTabs.length ? undefined : RouteNames.BUILDER_QUICKSTART_TAB
        },
        ...mapGetters(['getAudience']), 
        ...mapState(['audiences','loadingAudiences'])
    },
    methods: {
        async removeAudience(id) {
            
            try {
                this.loading = true;
                await this.deleteAudience(id);
                bootstrapSuccessGrowl(this.resource('AudienceManager_Overview_Concept_Delete_Succeeded_Message'));
            } catch(error) {
                console.error(error);
                bootstrapDangerGrowl(this.resource('AudienceManager_Overview_Concept_Delete_Failed_Message'));
            }
            
            this.loading = false;
            this.idToDelete = null;
        }, 
        async navigateToBuilder(id){
            await this.$router.push({
                name: RouteNames.BUILDER_OVERVIEW_TAB,
                params: { audienceId: id }
            });
            
            // await this.$router.push({
            //     name: this.targetBuilderTab, 
            //     params: { audienceId: id, tabId: this.targetTabId } 
            // });
        },
        ...mapActions(['deleteAudience'])
    },
    data() {
        return {
            idToDelete: null
        };
    }
};